<template>

  <div class="user">

    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" v-auth="'/plus/ad/ad/add'" 
      type="primary" @click="addClick">添加广告（广告、关键字、商品排名,诚优企业）</el-button>
    </div>

    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="">
          <el-select v-model="formInline.code" placeholder="广告类型">
            <el-option label="全部" value=""></el-option>
            <el-option label="广告" value="ad"></el-option>
            <el-option label="关键字" value="keyword"></el-option>
            <el-option label="商品排名" value="store"></el-option>
            <el-option label="诚优企业" value="coc"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-input v-model="formInline.name" placeholder="请输入广告名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    
    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="name" label="名称"></el-table-column>
            <el-table-column prop="type" label="类型">
                <template slot-scope="scope">
                  <div v-if="scope.row.code == 'ad'">
                    广告
                  </div>
                  <div v-if="scope.row.code == 'kkeyword'">
                    关键字
                  </div>
                  <div v-if="scope.row.code == 'store'">
                    商品排序
                  </div>
                  <div v-if="scope.row.code == 'coc'">
                  诚优企业
                  </div>

               </template>	
            </el-table-column>   
            <el-table-column prop="keyword" label="关键词"></el-table-column>
            <el-table-column prop="type" label="多图/单图">
                <template slot-scope="scope">
                  <div v-if="scope.row.type == '1' && scope.row.code == 'ad'">
                    bannar（多图）
                  </div>
                  <div v-if="scope.row.type == '2'  && scope.row.code == 'ad'">
                    单图
                  </div>
               </template>	
            </el-table-column>   
          <el-table-column prop="location"  label="位置"> </el-table-column>
          <el-table-column label="详细信息" width="300">
            <template slot-scope="scope">
              
              <table v-if="scope.row.setting" border cellspacing="0" class="mt10" style="border:1px solid #b8b8b8">
             <tr  style="border:1px solid #b8b8b8">
               <th class="w150" >位置</th>
               <th class="w150" >价格（元/天）</th>
               <th class="w150" >是否售出</th>
               <th class="w150" >是否开启</th>
             </tr>

             <tr v-for="(item,index) in scope.row.setting" v-if=" (scope.row.type == '1' )" style="border:1px solid #b8b8b8">
               <td class="tc">{{ item.index }} </td>
               <td class="tc">
                {{ item.price }}
               </td>
               <td class="tc">
                <span v-if="item.is_sell == 0">未售出</span>
                <span v-if="item.is_sell == 1">已售出</span>
              </td>
              <td class="tc">
                <span v-if="item.status == 0">未开启</span>
                <span v-if="item.status == 1">已开启</span>

              </td>
             </tr>

             <tr v-for="(item,index) in scope.row.setting" v-if=" (scope.row.type == '2' && index<1 )" style="border:1px solid #b8b8b8">
               <td class="tc">{{ item.index }} </td>
               <td class="tc">
                {{ item.price }}
               </td>
               <td class="tc">
                <span v-if="item.is_sell == 0">未售出</span>
                <span v-if="item.is_sell == 1">已售出</span>
              </td>
              <td class="tc">
                <span v-if="item.status == 0">未开启</span>
                <span v-if="item.status == 1">已开启</span>

              </td>
             </tr>
           </table>
              
             
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import AdApi from '@/api/ad.js';
export default {
  components: {},
  inject: ['reload'],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单对象*/
      form: {},
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      formInline: {},
      status: ['未开始', '进行中', '已结束'],
      formInline:{
        code:"",
        name:""
      }
    };
  },
  created() {

    /*获取列表*/
    this.getTableList();
  },
  methods: {
    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = this.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      AdApi.adList(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {});
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },

    /*添加活动*/
    addClick() {
      this.$router.push('/plus/ad/ad/add');
    },

    /*编辑活动*/
    editClick(row) {
      let ad_id = row.ad_id;
      this.$router.push({
        path: '/plus/ad/ad/edit',
        query: {
          ad_id: ad_id
        }
      });
    },

    /*删除*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          AdApi.delAd(
            {
              ad_id: row.ad_id
            },
            true
          )
            .then(data => {
              if (data.code == 1) {
                self.$message({
                  message: '删除成功',
                  type: 'success'
                });
                this.onSubmit();
              } else {
                self.$message.error('错了哦，这是一条错误消息');
              }
            })
            .catch(error => {});
        })
        .catch(() => {});
    }
  }
};
</script>

<style>
.w150{
    border: 1px solid #eee;
  }
  .tc{
    border: 1px solid #eee;
  }
</style>



// WEBPACK FOOTER //
// src/views/plus/ad/ad/index.vue